import { useLang } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-line bg-coal py-5" aria-hidden="true">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {items.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-8 pr-8 font-display text-sm font-bold uppercase tracking-[0.3em] text-ash"
              >
                {item}
                <span className="inline-block h-1.5 w-1.5 rotate-45 bg-ember" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
